import { State } from "./state";
import { GetterTree } from "vuex";

import { getError, getIsLoading, getDataItem, getSuccess, getDataList, getTotal, getId } from "@/store/Crud/functions/getters";
import { getCancelInvoice, getCancelInvoiceError, getCancelInvoiceLoading, getCancelInvoiceSuccess } from "@/store/PaymentWorkflow/getters";

export default <GetterTree<State, any>>{
  getError,
  getIsLoading,
  getDataItem,
  getSuccess,
  getDataList,
  getTotal,
  getId,
  getCancelInvoiceSuccess,
  getCancelInvoiceError,
  getCancelInvoice,
  getCancelInvoiceLoading,
};
